module.exports = __webpack_public_path__ + "img/EarnBitcoin.3199a322_3199a322edae452f2d9d90e435de554c.3199a322.svg";